/**
 * Tour Template: Header Glass-Hintergrund
 * Nur auf product.tour aktiv. Fügt body-Klasse hinzu wenn Header über Hero (oben).
 * Ermöglicht zuverlässigen Glass-Effekt auch bei Scroll-up.
 */
(function() {
  function init() {
    if (!document.body || !document.body.classList.contains('template-product-tour')) return;
    if (!document.querySelector('.shopify-section:first-child [allow-transparent-header]')) return;

    var header = document.querySelector('.shopify-section-header');
    if (!header || !header.querySelector('.header-wrapper')) return;

    var threshold = 120;
    var ticking = false;

    function update() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollY < threshold) {
        document.body.classList.add('tour-header-over-hero');
      } else {
        document.body.classList.remove('tour-header-over-hero');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
